<template>
  <v-app>
    <global-dialog />
    <router-view />
  </v-app>
</template>

<script>
import GlobalDialog from "./components/helpers/GlobalDialog";

export default {
  name: "App",
  components: {
    GlobalDialog,
  },
  data: () => ({}),
  computed: {},
  created() {},
  mounted() {},
  watch: {},
};
</script>

<style>
html {
  overflow: auto !important;
}

body {
  overflow: auto !important;
}

.routercontainer {
  display: flex !important;
  height: 100% !important;
  width: 100% !important;
  overflow: hidden !important;
}

.noselect {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  -moz-user-select: none;
}

.centered-input,
.centered-input label,
.centered-input input,
.centered-input v-input__control v-input__slot v-text-field__slot label {
  text-align: center;
}

.centered-input .v-select__selection {
  width: 100%;
  justify-content: center;
  text-align: center;
}

.centered-input input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.centered-input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.centered-input input::-webkit-outer-spin-button,
.centered-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  display: none;
  margin: 0;
}

.centered-input::-webkit-outer-spin-button,
.centered-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.component-container-light {
  background-color: #fff;
  color: #000;
}

.component-container-dark {
  background-color: #222;
  color: #fff;
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
* {
  text-transform: none !important;
}

.light .v-virtual-scroll,
.light .row-content,
.light .v-menu__content,
.light .customscroll {
  overflow-y: auto;
  scrollbar-color: rgb(170, 170, 170) rgb(238, 238, 238);
}

.dark .v-virtual-scroll,
.dark .row-content,
.dark .v-menu__content,
.dark .customscroll {
  overflow-y: auto;
  scrollbar-color: #111 #666;
}

.light ::-webkit-scrollbar {
  /* width */
  width: 12px;
  height: 12px;
}
/* button */
/* .light ::-webkit-scrollbar-button {
    background: #555;
} */
.light ::-webkit-scrollbar-thumb {
  /* Handle */
  background: rgb(136, 136, 136);
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgb(119, 119, 119);
  box-shadow: inset 0 0 6px rgb(119, 119, 119);
}
.light ::-webkit-scrollbar-thumb:hover {
  /* Handle on hover */
  background: rgb(153, 153, 153);
}
.light ::-webkit-scrollbar-corner {
  /* Corner */
  background: rgb(170, 170, 170);
}
.light ::-webkit-resizer {
  /* Resizer */
  background: rgb(170, 170, 170);
}
.light ::-webkit-scrollbar-track {
  /* Track */
  background: #ddd;
}
/* The track NOT covered by the handle.
::-webkit-scrollbar-track-piece {
    background: #000;
} */

.dark ::-webkit-scrollbar {
  /* width */
  width: 12px;
  height: 12px;
}
/* button */
/* .dark ::-webkit-scrollbar-button {
    background: #444; 
}*/
.dark ::-webkit-scrollbar-thumb {
  /* Handle */
  background: #666;
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(51, 51, 51, 0.5);
  box-shadow: inset 0 0 6px rgba(51, 51, 51, 0.5);
}
.dark ::-webkit-scrollbar-thumb:hover {
  /* Handle on hover */
  background: #555;
}
.dark ::-webkit-scrollbar-corner {
  /* Corner */
  background: #888;
}
.dark ::-webkit-resizer {
  /* Resizer */
  background: #888;
}
.dark ::-webkit-scrollbar-track {
  /* Track */
  background: #888;
}
/* The track NOT covered by the handle.
::-webkit-scrollbar-track-piece {
    background: #000;
} */

.box-container {
  display: flex;
  overflow: hidden !important;
  flex-flow: column;
  max-height: 100% !important;
  height: 100%;
}

.box-container-horizontal {
  display: flex;
  overflow: hidden !important;
  flex-flow: row;
  width: 100%;
}

.box-container .row-header,
.box-container-horizontal .row-header {
  flex: 0 1 auto;
  overflow-y: unset !important;
}

.box-container .row-content,
.box-container-horizontal .row-content {
  flex: 1 1 auto;
  overflow-y: auto;
  max-height: 100% !important;
}

.box-container .row-content-limited,
.box-container-horizontal .row-content-limited {
  flex: 1 1 100;
  overflow-y: auto;
}

.box-container .row-content-horizontal-scroll {
  flex: 1 1 auto;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  overflow-x: auto;
  overflow-y: none;
}

.animated_background {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  background: #f3f9ff;
}

.custom_hover_shadow {
  transition: box-shadow 0.2s;
}

.custom_hover_shadow:hover {
  box-shadow: 0 0 20px rgba(33, 33, 33, 0.5);
}

.no-background-hover::before {
  background-color: transparent !important;
  cursor: pointer;
}

.text-custom {
  text-align: justify;
  text-justify: inter-word;
  text-indent: 1em;
}

.scroll-left {
  height: 20px;
  overflow: hidden;
  position: relative;
}
.scroll-left p {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  line-height: 20px;
  text-align: center;
  /* Starting position */
  -moz-transform: translateX(100%);
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
  /* Apply animation to this element */
  -moz-animation: scroll-left 15s linear infinite;
  -webkit-animation: scroll-left 15s linear infinite;
  animation: scroll-left 15s linear infinite;
}
/* Move it (define the animation) */
@-moz-keyframes scroll-left {
  0% {
    -moz-transform: translateX(100%);
  }
  100% {
    -moz-transform: translateX(-100%);
  }
}
@-webkit-keyframes scroll-left {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(-100%);
  }
}
@keyframes scroll-left {
  0% {
    -moz-transform: translateX(100%); /* Browser bug fix */
    -webkit-transform: translateX(100%); /* Browser bug fix */
    transform: translateX(100%);
  }
  100% {
    -moz-transform: translateX(-100%); /* Browser bug fix */
    -webkit-transform: translateX(-100%); /* Browser bug fix */
    transform: translateX(-100%);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

/* v-select.myselect > .v-input__control > .v-input__slot > input,
v-select.myselect.v-text-field > input, */
/* .v-input__control .v-input__slot .v-select__slot .v-select__selections > input {
  max-width: 0px;
} 
.mytextfield.v-text-field .v-input__control .v-input__slot .v-text-field__slot > input {
    max-width: 0px;
  width: auto;
} */

.v-navigation-drawer {
  z-index: 99999 !important;
}

.v-list-item.v-list-item--link div.v-list-item__action {
  margin: 6px !important;
  padding-left: 0px;
}

.mytextfield.v-text-field .v-input__control .v-input__slot,
.myselect.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: block !important;
  align-items: center !important;
}

.mytextfield .v-input__slot .v-label,
.mytextfield .v-input__slot .v-input__append-inner,
.mytextfield .v-input__slot .v-input__prepend-inner,
.myselect.v-text-field .v-select__slot .v-label,
.myselect.v-text-field .v-select__slot .v-input__append-inner,
v-field__append-inner .myselect.v-text-field .v-select__slot .v-input__prepend-inner {
  align-self: center;
  position: static !important;
  margin: 0px !important;
  padding: auto !important;
}

.mytextfield .v-field.v-field--appended {
  padding-right: 0 !important;
}

.defect {
  height: 100px;
  width: 100px;
  background-color: #fa6900;
  border-radius: 5px;
}
.defect:after {
  position: relative;
  content: "\d7";
  font-size: 177px;
  color: white;
  font-weight: bold;
  top: -53px;
  left: -2px;
}

/* .Online {
  border: 2px solid rgb(19, 185, 19);
} */

.ConnectorSelected {
  border: 2px dashed rgb(19, 185, 19);
}

.Offline {
  border: 2px solid red !important ;
  outline-color: red !important;
}

.v-theme--light .NotConnected {
  background: lightgray !important;
}
.v-theme--dark .NotConnected {
  background: rgb(102, 102, 102) !important;
}

/* 
.v-list-item >>> span {
  font-size: 14px;
}

.v-list-group >>> span {
  font-size: 14px;
}

.closeBtn:hover:before {
  background-color: transparent;
}

div >>> .v-toolbar__content {
  padding: 0;
}

div >>> .v-banner__wrapper {
  border: 5px solid yellow;
}

div >>> .tremol-logo-btn {
  justify-content: start;
}

.bordered-item {
  margin: auto;
  display: flex;
  width: 204px;
  height: 204px;
}

.v-menu {
  margin-top: 40px;
  contain: initial;
  overflow: visible;
}
.v-menu::before {
  position: absolute;
  content: "";
  top: 0;
  right: 10px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #fff;
} */
</style>